/* eslint-disable */
// Generated by scripts/build-index.mjs — do not edit.

const globalColorHex = require('../tokens/global/color/hex.json')
const globalColorHsl = require('../tokens/global/color/hsl.json')
const globalColorOklch = require('../tokens/global/color/oklch.json')
const globalColorRgb = require('../tokens/global/color/rgb.json')
const semanticColorHex = require('../tokens/semantic/color/hex.json')
const semanticColorHsl = require('../tokens/semantic/color/hsl.json')
const semanticColorOklch = require('../tokens/semantic/color/oklch.json')
const semanticColorRgb = require('../tokens/semantic/color/rgb.json')
const semanticColorHexDark = require('../tokens/semantic/color/hex.dark.json')
const semanticColorHslDark = require('../tokens/semantic/color/hsl.dark.json')
const semanticColorOklchDark = require('../tokens/semantic/color/oklch.dark.json')
const semanticColorRgbDark = require('../tokens/semantic/color/rgb.dark.json')
const masterbrandColorHex = require('../tokens/themes/color/masterbrand/hex.json')
const masterbrandColorHsl = require('../tokens/themes/color/masterbrand/hsl.json')
const masterbrandColorOklch = require('../tokens/themes/color/masterbrand/oklch.json')
const masterbrandColorRgb = require('../tokens/themes/color/masterbrand/rgb.json')
const fuchsiaBlueColorHex = require('../tokens/themes/color/fuchsia-blue/hex.json')
const fuchsiaBlueColorHsl = require('../tokens/themes/color/fuchsia-blue/hsl.json')
const fuchsiaBlueColorOklch = require('../tokens/themes/color/fuchsia-blue/oklch.json')
const fuchsiaBlueColorRgb = require('../tokens/themes/color/fuchsia-blue/rgb.json')
const fuchsiaOrangeColorHex = require('../tokens/themes/color/fuchsia-orange/hex.json')
const fuchsiaOrangeColorHsl = require('../tokens/themes/color/fuchsia-orange/hsl.json')
const fuchsiaOrangeColorOklch = require('../tokens/themes/color/fuchsia-orange/oklch.json')
const fuchsiaOrangeColorRgb = require('../tokens/themes/color/fuchsia-orange/rgb.json')
const dataVisualisationColorHex = require('../tokens/themes/color/data-visualisation/hex.json')
const dataVisualisationColorHsl = require('../tokens/themes/color/data-visualisation/hsl.json')
const dataVisualisationColorOklch = require('../tokens/themes/color/data-visualisation/oklch.json')
const dataVisualisationColorRgb = require('../tokens/themes/color/data-visualisation/rgb.json')

import globalCssHex from './css/colors/global/hex.css'
import globalCssHsl from './css/colors/global/hsl.css'
import globalCssOklch from './css/colors/global/oklch.css'
import globalCssRgb from './css/colors/global/rgb.css'
import semanticCssHex from './css/colors/semantic/hex.css'
import semanticCssHsl from './css/colors/semantic/hsl.css'
import semanticCssOklch from './css/colors/semantic/oklch.css'
import semanticCssRgb from './css/colors/semantic/rgb.css'
import semanticCssHexDark from './css/colors/semantic/hex.dark.css'
import semanticCssHslDark from './css/colors/semantic/hsl.dark.css'
import semanticCssOklchDark from './css/colors/semantic/oklch.dark.css'
import semanticCssRgbDark from './css/colors/semantic/rgb.dark.css'
import semanticCssHexDarkMedia from './css/colors/semantic/hex.dark-media.css'
import semanticCssHslDarkMedia from './css/colors/semantic/hsl.dark-media.css'
import semanticCssOklchDarkMedia from './css/colors/semantic/oklch.dark-media.css'
import semanticCssRgbDarkMedia from './css/colors/semantic/rgb.dark-media.css'
import masterbrandCssHex from './css/colors/themes/masterbrand/hex.css'
import masterbrandCssHsl from './css/colors/themes/masterbrand/hsl.css'
import masterbrandCssOklch from './css/colors/themes/masterbrand/oklch.css'
import masterbrandCssRgb from './css/colors/themes/masterbrand/rgb.css'
import fuchsiaBlueCssHex from './css/colors/themes/fuchsia-blue/hex.css'
import fuchsiaBlueCssHsl from './css/colors/themes/fuchsia-blue/hsl.css'
import fuchsiaBlueCssOklch from './css/colors/themes/fuchsia-blue/oklch.css'
import fuchsiaBlueCssRgb from './css/colors/themes/fuchsia-blue/rgb.css'
import fuchsiaOrangeCssHex from './css/colors/themes/fuchsia-orange/hex.css'
import fuchsiaOrangeCssHsl from './css/colors/themes/fuchsia-orange/hsl.css'
import fuchsiaOrangeCssOklch from './css/colors/themes/fuchsia-orange/oklch.css'
import fuchsiaOrangeCssRgb from './css/colors/themes/fuchsia-orange/rgb.css'
import dataVisualisationCssHex from './css/colors/themes/data-visualisation/hex.css'
import dataVisualisationCssHsl from './css/colors/themes/data-visualisation/hsl.css'
import dataVisualisationCssOklch from './css/colors/themes/data-visualisation/oklch.css'
import dataVisualisationCssRgb from './css/colors/themes/data-visualisation/rgb.css'
import spaceCssGlobal from './css/space/global.css'
import radiusCssGlobal from './css/radius/global.css'
import breakpointsCssGlobal from './css/breakpoints/global.css'
import typographyCssGlobal from './css/typography/global.css'
import typographyCssSemantic from './css/typography/semantic.css'
import borderCssGlobal from './css/border/global.css'
import shadowCssGlobal from './css/shadow/global.css'
import motionCssGlobal from './css/motion/global.css'
import zIndexCssGlobal from './css/z-index/global.css'

import * as globalJsHex from './js/colors/global/hex.js'
import * as globalJsHsl from './js/colors/global/hsl.js'
import * as globalJsOklch from './js/colors/global/oklch.js'
import * as globalJsRgb from './js/colors/global/rgb.js'
import * as semanticJsHex from './js/colors/semantic/hex.js'
import * as semanticJsHsl from './js/colors/semantic/hsl.js'
import * as semanticJsOklch from './js/colors/semantic/oklch.js'
import * as semanticJsRgb from './js/colors/semantic/rgb.js'
import * as semanticJsHexDark from './js/colors/semantic/hex.dark.js'
import * as semanticJsHslDark from './js/colors/semantic/hsl.dark.js'
import * as semanticJsOklchDark from './js/colors/semantic/oklch.dark.js'
import * as semanticJsRgbDark from './js/colors/semantic/rgb.dark.js'
import * as masterbrandJsHex from './js/colors/themes/masterbrand/hex.js'
import * as masterbrandJsHsl from './js/colors/themes/masterbrand/hsl.js'
import * as masterbrandJsOklch from './js/colors/themes/masterbrand/oklch.js'
import * as masterbrandJsRgb from './js/colors/themes/masterbrand/rgb.js'
import * as fuchsiaBlueJsHex from './js/colors/themes/fuchsia-blue/hex.js'
import * as fuchsiaBlueJsHsl from './js/colors/themes/fuchsia-blue/hsl.js'
import * as fuchsiaBlueJsOklch from './js/colors/themes/fuchsia-blue/oklch.js'
import * as fuchsiaBlueJsRgb from './js/colors/themes/fuchsia-blue/rgb.js'
import * as fuchsiaOrangeJsHex from './js/colors/themes/fuchsia-orange/hex.js'
import * as fuchsiaOrangeJsHsl from './js/colors/themes/fuchsia-orange/hsl.js'
import * as fuchsiaOrangeJsOklch from './js/colors/themes/fuchsia-orange/oklch.js'
import * as fuchsiaOrangeJsRgb from './js/colors/themes/fuchsia-orange/rgb.js'
import * as dataVisualisationJsHex from './js/colors/themes/data-visualisation/hex.js'
import * as dataVisualisationJsHsl from './js/colors/themes/data-visualisation/hsl.js'
import * as dataVisualisationJsOklch from './js/colors/themes/data-visualisation/oklch.js'
import * as dataVisualisationJsRgb from './js/colors/themes/data-visualisation/rgb.js'
import * as spaceJsGlobal from './js/space/global.js'
import * as radiusJsGlobal from './js/radius/global.js'
import * as breakpointsJsGlobal from './js/breakpoints/global.js'
import * as typographyJsGlobal from './js/typography/global.js'
import * as typographyJsSemantic from './js/typography/semantic.js'
import * as borderJsGlobal from './js/border/global.js'
import * as shadowJsGlobal from './js/shadow/global.js'
import * as motionJsGlobal from './js/motion/global.js'
import * as zIndexJsGlobal from './js/z-index/global.js'

const globalJsonHex = require('./json/colors/global/hex.json')
const globalJsonHsl = require('./json/colors/global/hsl.json')
const globalJsonOklch = require('./json/colors/global/oklch.json')
const globalJsonRgb = require('./json/colors/global/rgb.json')
const semanticJsonHex = require('./json/colors/semantic/hex.json')
const semanticJsonHsl = require('./json/colors/semantic/hsl.json')
const semanticJsonOklch = require('./json/colors/semantic/oklch.json')
const semanticJsonRgb = require('./json/colors/semantic/rgb.json')
const semanticJsonHexDark = require('./json/colors/semantic/hex.dark.json')
const semanticJsonHslDark = require('./json/colors/semantic/hsl.dark.json')
const semanticJsonOklchDark = require('./json/colors/semantic/oklch.dark.json')
const semanticJsonRgbDark = require('./json/colors/semantic/rgb.dark.json')
const masterbrandJsonHex = require('./json/colors/themes/masterbrand/hex.json')
const masterbrandJsonHsl = require('./json/colors/themes/masterbrand/hsl.json')
const masterbrandJsonOklch = require('./json/colors/themes/masterbrand/oklch.json')
const masterbrandJsonRgb = require('./json/colors/themes/masterbrand/rgb.json')
const fuchsiaBlueJsonHex = require('./json/colors/themes/fuchsia-blue/hex.json')
const fuchsiaBlueJsonHsl = require('./json/colors/themes/fuchsia-blue/hsl.json')
const fuchsiaBlueJsonOklch = require('./json/colors/themes/fuchsia-blue/oklch.json')
const fuchsiaBlueJsonRgb = require('./json/colors/themes/fuchsia-blue/rgb.json')
const fuchsiaOrangeJsonHex = require('./json/colors/themes/fuchsia-orange/hex.json')
const fuchsiaOrangeJsonHsl = require('./json/colors/themes/fuchsia-orange/hsl.json')
const fuchsiaOrangeJsonOklch = require('./json/colors/themes/fuchsia-orange/oklch.json')
const fuchsiaOrangeJsonRgb = require('./json/colors/themes/fuchsia-orange/rgb.json')
const dataVisualisationJsonHex = require('./json/colors/themes/data-visualisation/hex.json')
const dataVisualisationJsonHsl = require('./json/colors/themes/data-visualisation/hsl.json')
const dataVisualisationJsonOklch = require('./json/colors/themes/data-visualisation/oklch.json')
const dataVisualisationJsonRgb = require('./json/colors/themes/data-visualisation/rgb.json')
const spaceJsonGlobal = require('./json/space/global.json')
const radiusJsonGlobal = require('./json/radius/global.json')
const breakpointsJsonGlobal = require('./json/breakpoints/global.json')
const typographyJsonGlobal = require('./json/typography/global.json')
const typographyJsonSemantic = require('./json/typography/semantic.json')
const borderJsonGlobal = require('./json/border/global.json')
const shadowJsonGlobal = require('./json/shadow/global.json')
const motionJsonGlobal = require('./json/motion/global.json')
const zIndexJsonGlobal = require('./json/z-index/global.json')

import globalLessHex from './less/colors/global/hex.less'
import globalLessHsl from './less/colors/global/hsl.less'
import globalLessOklch from './less/colors/global/oklch.less'
import globalLessRgb from './less/colors/global/rgb.less'
import semanticLessHex from './less/colors/semantic/hex.less'
import semanticLessHsl from './less/colors/semantic/hsl.less'
import semanticLessOklch from './less/colors/semantic/oklch.less'
import semanticLessRgb from './less/colors/semantic/rgb.less'
import semanticLessHexDark from './less/colors/semantic/hex.dark.less'
import semanticLessHslDark from './less/colors/semantic/hsl.dark.less'
import semanticLessOklchDark from './less/colors/semantic/oklch.dark.less'
import semanticLessRgbDark from './less/colors/semantic/rgb.dark.less'
import masterbrandLessHex from './less/colors/themes/masterbrand/hex.less'
import masterbrandLessHsl from './less/colors/themes/masterbrand/hsl.less'
import masterbrandLessOklch from './less/colors/themes/masterbrand/oklch.less'
import masterbrandLessRgb from './less/colors/themes/masterbrand/rgb.less'
import fuchsiaBlueLessHex from './less/colors/themes/fuchsia-blue/hex.less'
import fuchsiaBlueLessHsl from './less/colors/themes/fuchsia-blue/hsl.less'
import fuchsiaBlueLessOklch from './less/colors/themes/fuchsia-blue/oklch.less'
import fuchsiaBlueLessRgb from './less/colors/themes/fuchsia-blue/rgb.less'
import fuchsiaOrangeLessHex from './less/colors/themes/fuchsia-orange/hex.less'
import fuchsiaOrangeLessHsl from './less/colors/themes/fuchsia-orange/hsl.less'
import fuchsiaOrangeLessOklch from './less/colors/themes/fuchsia-orange/oklch.less'
import fuchsiaOrangeLessRgb from './less/colors/themes/fuchsia-orange/rgb.less'
import dataVisualisationLessHex from './less/colors/themes/data-visualisation/hex.less'
import dataVisualisationLessHsl from './less/colors/themes/data-visualisation/hsl.less'
import dataVisualisationLessOklch from './less/colors/themes/data-visualisation/oklch.less'
import dataVisualisationLessRgb from './less/colors/themes/data-visualisation/rgb.less'
import spaceLessGlobal from './less/space/global.less'
import radiusLessGlobal from './less/radius/global.less'
import breakpointsLessGlobal from './less/breakpoints/global.less'
import typographyLessGlobal from './less/typography/global.less'
import typographyLessSemantic from './less/typography/semantic.less'
import borderLessGlobal from './less/border/global.less'
import shadowLessGlobal from './less/shadow/global.less'
import motionLessGlobal from './less/motion/global.less'
import zIndexLessGlobal from './less/z-index/global.less'

import globalScssHex from './scss/colors/global/hex.scss'
import globalScssHsl from './scss/colors/global/hsl.scss'
import globalScssOklch from './scss/colors/global/oklch.scss'
import globalScssRgb from './scss/colors/global/rgb.scss'
import semanticScssHex from './scss/colors/semantic/hex.scss'
import semanticScssHsl from './scss/colors/semantic/hsl.scss'
import semanticScssOklch from './scss/colors/semantic/oklch.scss'
import semanticScssRgb from './scss/colors/semantic/rgb.scss'
import semanticScssHexDark from './scss/colors/semantic/hex.dark.scss'
import semanticScssHslDark from './scss/colors/semantic/hsl.dark.scss'
import semanticScssOklchDark from './scss/colors/semantic/oklch.dark.scss'
import semanticScssRgbDark from './scss/colors/semantic/rgb.dark.scss'
import masterbrandScssHex from './scss/colors/themes/masterbrand/hex.scss'
import masterbrandScssHsl from './scss/colors/themes/masterbrand/hsl.scss'
import masterbrandScssOklch from './scss/colors/themes/masterbrand/oklch.scss'
import masterbrandScssRgb from './scss/colors/themes/masterbrand/rgb.scss'
import fuchsiaBlueScssHex from './scss/colors/themes/fuchsia-blue/hex.scss'
import fuchsiaBlueScssHsl from './scss/colors/themes/fuchsia-blue/hsl.scss'
import fuchsiaBlueScssOklch from './scss/colors/themes/fuchsia-blue/oklch.scss'
import fuchsiaBlueScssRgb from './scss/colors/themes/fuchsia-blue/rgb.scss'
import fuchsiaOrangeScssHex from './scss/colors/themes/fuchsia-orange/hex.scss'
import fuchsiaOrangeScssHsl from './scss/colors/themes/fuchsia-orange/hsl.scss'
import fuchsiaOrangeScssOklch from './scss/colors/themes/fuchsia-orange/oklch.scss'
import fuchsiaOrangeScssRgb from './scss/colors/themes/fuchsia-orange/rgb.scss'
import dataVisualisationScssHex from './scss/colors/themes/data-visualisation/hex.scss'
import dataVisualisationScssHsl from './scss/colors/themes/data-visualisation/hsl.scss'
import dataVisualisationScssOklch from './scss/colors/themes/data-visualisation/oklch.scss'
import dataVisualisationScssRgb from './scss/colors/themes/data-visualisation/rgb.scss'
import spaceScssGlobal from './scss/space/global.scss'
import radiusScssGlobal from './scss/radius/global.scss'
import breakpointsScssGlobal from './scss/breakpoints/global.scss'
import typographyScssGlobal from './scss/typography/global.scss'
import typographyScssSemantic from './scss/typography/semantic.scss'
import borderScssGlobal from './scss/border/global.scss'
import shadowScssGlobal from './scss/shadow/global.scss'
import motionScssGlobal from './scss/motion/global.scss'
import zIndexScssGlobal from './scss/z-index/global.scss'

import globalTailwindHex from './tailwind/colors/global/hex.css'
import globalTailwindHsl from './tailwind/colors/global/hsl.css'
import globalTailwindOklch from './tailwind/colors/global/oklch.css'
import globalTailwindRgb from './tailwind/colors/global/rgb.css'
import semanticTailwindHex from './tailwind/colors/semantic/hex.css'
import semanticTailwindHsl from './tailwind/colors/semantic/hsl.css'
import semanticTailwindOklch from './tailwind/colors/semantic/oklch.css'
import semanticTailwindRgb from './tailwind/colors/semantic/rgb.css'
import masterbrandTailwindHex from './tailwind/colors/themes/masterbrand/hex.css'
import masterbrandTailwindHsl from './tailwind/colors/themes/masterbrand/hsl.css'
import masterbrandTailwindOklch from './tailwind/colors/themes/masterbrand/oklch.css'
import masterbrandTailwindRgb from './tailwind/colors/themes/masterbrand/rgb.css'
import fuchsiaBlueTailwindHex from './tailwind/colors/themes/fuchsia-blue/hex.css'
import fuchsiaBlueTailwindHsl from './tailwind/colors/themes/fuchsia-blue/hsl.css'
import fuchsiaBlueTailwindOklch from './tailwind/colors/themes/fuchsia-blue/oklch.css'
import fuchsiaBlueTailwindRgb from './tailwind/colors/themes/fuchsia-blue/rgb.css'
import fuchsiaOrangeTailwindHex from './tailwind/colors/themes/fuchsia-orange/hex.css'
import fuchsiaOrangeTailwindHsl from './tailwind/colors/themes/fuchsia-orange/hsl.css'
import fuchsiaOrangeTailwindOklch from './tailwind/colors/themes/fuchsia-orange/oklch.css'
import fuchsiaOrangeTailwindRgb from './tailwind/colors/themes/fuchsia-orange/rgb.css'
import dataVisualisationTailwindHex from './tailwind/colors/themes/data-visualisation/hex.css'
import dataVisualisationTailwindHsl from './tailwind/colors/themes/data-visualisation/hsl.css'
import dataVisualisationTailwindOklch from './tailwind/colors/themes/data-visualisation/oklch.css'
import dataVisualisationTailwindRgb from './tailwind/colors/themes/data-visualisation/rgb.css'
import spaceTailwindGlobal from './tailwind/space/global.css'
import radiusTailwindGlobal from './tailwind/radius/global.css'
import breakpointsTailwindGlobal from './tailwind/breakpoints/global.css'
import typographyTailwindGlobal from './tailwind/typography/global.css'
import borderTailwindGlobal from './tailwind/border/global.css'
import shadowTailwindGlobal from './tailwind/shadow/global.css'
import motionTailwindGlobal from './tailwind/motion/global.css'
import zIndexTailwindGlobal from './tailwind/z-index/global.css'

import * as globalTsHex from './ts/colors/global/hex.js'
import * as globalTsHsl from './ts/colors/global/hsl.js'
import * as globalTsOklch from './ts/colors/global/oklch.js'
import * as globalTsRgb from './ts/colors/global/rgb.js'
import * as semanticTsHex from './ts/colors/semantic/hex.js'
import * as semanticTsHsl from './ts/colors/semantic/hsl.js'
import * as semanticTsOklch from './ts/colors/semantic/oklch.js'
import * as semanticTsRgb from './ts/colors/semantic/rgb.js'
import * as semanticTsHexDark from './ts/colors/semantic/hex.dark.js'
import * as semanticTsHslDark from './ts/colors/semantic/hsl.dark.js'
import * as semanticTsOklchDark from './ts/colors/semantic/oklch.dark.js'
import * as semanticTsRgbDark from './ts/colors/semantic/rgb.dark.js'
import * as masterbrandTsHex from './ts/colors/themes/masterbrand/hex.js'
import * as masterbrandTsHsl from './ts/colors/themes/masterbrand/hsl.js'
import * as masterbrandTsOklch from './ts/colors/themes/masterbrand/oklch.js'
import * as masterbrandTsRgb from './ts/colors/themes/masterbrand/rgb.js'
import * as fuchsiaBlueTsHex from './ts/colors/themes/fuchsia-blue/hex.js'
import * as fuchsiaBlueTsHsl from './ts/colors/themes/fuchsia-blue/hsl.js'
import * as fuchsiaBlueTsOklch from './ts/colors/themes/fuchsia-blue/oklch.js'
import * as fuchsiaBlueTsRgb from './ts/colors/themes/fuchsia-blue/rgb.js'
import * as fuchsiaOrangeTsHex from './ts/colors/themes/fuchsia-orange/hex.js'
import * as fuchsiaOrangeTsHsl from './ts/colors/themes/fuchsia-orange/hsl.js'
import * as fuchsiaOrangeTsOklch from './ts/colors/themes/fuchsia-orange/oklch.js'
import * as fuchsiaOrangeTsRgb from './ts/colors/themes/fuchsia-orange/rgb.js'
import * as dataVisualisationTsHex from './ts/colors/themes/data-visualisation/hex.js'
import * as dataVisualisationTsHsl from './ts/colors/themes/data-visualisation/hsl.js'
import * as dataVisualisationTsOklch from './ts/colors/themes/data-visualisation/oklch.js'
import * as dataVisualisationTsRgb from './ts/colors/themes/data-visualisation/rgb.js'
import * as spaceTsGlobal from './ts/space/global.js'
import * as radiusTsGlobal from './ts/radius/global.js'
import * as breakpointsTsGlobal from './ts/breakpoints/global.js'
import * as typographyTsGlobal from './ts/typography/global.js'
import * as typographyTsSemantic from './ts/typography/semantic.js'
import * as borderTsGlobal from './ts/border/global.js'
import * as shadowTsGlobal from './ts/shadow/global.js'
import * as motionTsGlobal from './ts/motion/global.js'
import * as zIndexTsGlobal from './ts/z-index/global.js'

export const tokens: {
  colors: {
    global: { hex: any, hsl: any, oklch: any, rgb: any };
    semantic: { hex: any, hsl: any, oklch: any, rgb: any, dark: { hex: any, hsl: any, oklch: any, rgb: any } };
    themes: {
      "masterbrand": { hex: any, hsl: any, oklch: any, rgb: any };
      "fuchsia-blue": { hex: any, hsl: any, oklch: any, rgb: any };
      "fuchsia-orange": { hex: any, hsl: any, oklch: any, rgb: any };
      "data-visualisation": { hex: any, hsl: any, oklch: any, rgb: any };
    };
  };
  css: {
    global: { hex: string, hsl: string, oklch: string, rgb: string };
    semantic: { hex: string, hsl: string, oklch: string, rgb: string, dark: { hex: string, hsl: string, oklch: string, rgb: string }, darkMedia: { hex: string, hsl: string, oklch: string, rgb: string } };
    themes: {
      "masterbrand": { hex: string, hsl: string, oklch: string, rgb: string };
      "fuchsia-blue": { hex: string, hsl: string, oklch: string, rgb: string };
      "fuchsia-orange": { hex: string, hsl: string, oklch: string, rgb: string };
      "data-visualisation": { hex: string, hsl: string, oklch: string, rgb: string };
    };
    space: { global: string };
    radius: { global: string };
    breakpoints: { global: string };
    typography: { global: string; semantic: string };
    border: { global: string };
    shadow: { global: string };
    motion: { global: string };
    zIndex: { global: string };
  };
  js: {
    global: { hex: typeof globalJsHex, hsl: typeof globalJsHsl, oklch: typeof globalJsOklch, rgb: typeof globalJsRgb };
    semantic: { hex: typeof semanticJsHex, hsl: typeof semanticJsHsl, oklch: typeof semanticJsOklch, rgb: typeof semanticJsRgb, dark: { hex: typeof semanticJsHexDark, hsl: typeof semanticJsHslDark, oklch: typeof semanticJsOklchDark, rgb: typeof semanticJsRgbDark } };
    themes: {
      "masterbrand": { hex: typeof masterbrandJsHex, hsl: typeof masterbrandJsHsl, oklch: typeof masterbrandJsOklch, rgb: typeof masterbrandJsRgb };
      "fuchsia-blue": { hex: typeof fuchsiaBlueJsHex, hsl: typeof fuchsiaBlueJsHsl, oklch: typeof fuchsiaBlueJsOklch, rgb: typeof fuchsiaBlueJsRgb };
      "fuchsia-orange": { hex: typeof fuchsiaOrangeJsHex, hsl: typeof fuchsiaOrangeJsHsl, oklch: typeof fuchsiaOrangeJsOklch, rgb: typeof fuchsiaOrangeJsRgb };
      "data-visualisation": { hex: typeof dataVisualisationJsHex, hsl: typeof dataVisualisationJsHsl, oklch: typeof dataVisualisationJsOklch, rgb: typeof dataVisualisationJsRgb };
    };
    space: { global: typeof spaceJsGlobal };
    radius: { global: typeof radiusJsGlobal };
    breakpoints: { global: typeof breakpointsJsGlobal };
    typography: { global: typeof typographyJsGlobal; semantic: typeof typographyJsSemantic };
    border: { global: typeof borderJsGlobal };
    shadow: { global: typeof shadowJsGlobal };
    motion: { global: typeof motionJsGlobal };
    zIndex: { global: typeof zIndexJsGlobal };
  };
  json: {
    global: { hex: any, hsl: any, oklch: any, rgb: any };
    semantic: { hex: any, hsl: any, oklch: any, rgb: any, dark: { hex: any, hsl: any, oklch: any, rgb: any } };
    themes: {
      "masterbrand": { hex: any, hsl: any, oklch: any, rgb: any };
      "fuchsia-blue": { hex: any, hsl: any, oklch: any, rgb: any };
      "fuchsia-orange": { hex: any, hsl: any, oklch: any, rgb: any };
      "data-visualisation": { hex: any, hsl: any, oklch: any, rgb: any };
    };
    space: { global: any };
    radius: { global: any };
    breakpoints: { global: any };
    typography: { global: any; semantic: any };
    border: { global: any };
    shadow: { global: any };
    motion: { global: any };
    zIndex: { global: any };
  };
  less: {
    global: { hex: string, hsl: string, oklch: string, rgb: string };
    semantic: { hex: string, hsl: string, oklch: string, rgb: string, dark: { hex: string, hsl: string, oklch: string, rgb: string } };
    themes: {
      "masterbrand": { hex: string, hsl: string, oklch: string, rgb: string };
      "fuchsia-blue": { hex: string, hsl: string, oklch: string, rgb: string };
      "fuchsia-orange": { hex: string, hsl: string, oklch: string, rgb: string };
      "data-visualisation": { hex: string, hsl: string, oklch: string, rgb: string };
    };
    space: { global: string };
    radius: { global: string };
    breakpoints: { global: string };
    typography: { global: string; semantic: string };
    border: { global: string };
    shadow: { global: string };
    motion: { global: string };
    zIndex: { global: string };
  };
  scss: {
    global: { hex: string, hsl: string, oklch: string, rgb: string };
    semantic: { hex: string, hsl: string, oklch: string, rgb: string, dark: { hex: string, hsl: string, oklch: string, rgb: string } };
    themes: {
      "masterbrand": { hex: string, hsl: string, oklch: string, rgb: string };
      "fuchsia-blue": { hex: string, hsl: string, oklch: string, rgb: string };
      "fuchsia-orange": { hex: string, hsl: string, oklch: string, rgb: string };
      "data-visualisation": { hex: string, hsl: string, oklch: string, rgb: string };
    };
    space: { global: string };
    radius: { global: string };
    breakpoints: { global: string };
    typography: { global: string; semantic: string };
    border: { global: string };
    shadow: { global: string };
    motion: { global: string };
    zIndex: { global: string };
  };
  tailwind: {
    global: { hex: string, hsl: string, oklch: string, rgb: string };
    semantic: { hex: string, hsl: string, oklch: string, rgb: string };
    themes: {
      "masterbrand": { hex: string, hsl: string, oklch: string, rgb: string };
      "fuchsia-blue": { hex: string, hsl: string, oklch: string, rgb: string };
      "fuchsia-orange": { hex: string, hsl: string, oklch: string, rgb: string };
      "data-visualisation": { hex: string, hsl: string, oklch: string, rgb: string };
    };
    space: { global: string };
    radius: { global: string };
    breakpoints: { global: string };
    typography: { global: string };
    border: { global: string };
    shadow: { global: string };
    motion: { global: string };
    zIndex: { global: string };
  };
  ts: {
    global: { hex: typeof globalTsHex, hsl: typeof globalTsHsl, oklch: typeof globalTsOklch, rgb: typeof globalTsRgb };
    semantic: { hex: typeof semanticTsHex, hsl: typeof semanticTsHsl, oklch: typeof semanticTsOklch, rgb: typeof semanticTsRgb, dark: { hex: typeof semanticTsHexDark, hsl: typeof semanticTsHslDark, oklch: typeof semanticTsOklchDark, rgb: typeof semanticTsRgbDark } };
    themes: {
      "masterbrand": { hex: typeof masterbrandTsHex, hsl: typeof masterbrandTsHsl, oklch: typeof masterbrandTsOklch, rgb: typeof masterbrandTsRgb };
      "fuchsia-blue": { hex: typeof fuchsiaBlueTsHex, hsl: typeof fuchsiaBlueTsHsl, oklch: typeof fuchsiaBlueTsOklch, rgb: typeof fuchsiaBlueTsRgb };
      "fuchsia-orange": { hex: typeof fuchsiaOrangeTsHex, hsl: typeof fuchsiaOrangeTsHsl, oklch: typeof fuchsiaOrangeTsOklch, rgb: typeof fuchsiaOrangeTsRgb };
      "data-visualisation": { hex: typeof dataVisualisationTsHex, hsl: typeof dataVisualisationTsHsl, oklch: typeof dataVisualisationTsOklch, rgb: typeof dataVisualisationTsRgb };
    };
    space: { global: typeof spaceTsGlobal };
    radius: { global: typeof radiusTsGlobal };
    breakpoints: { global: typeof breakpointsTsGlobal };
    typography: { global: typeof typographyTsGlobal; semantic: typeof typographyTsSemantic };
    border: { global: typeof borderTsGlobal };
    shadow: { global: typeof shadowTsGlobal };
    motion: { global: typeof motionTsGlobal };
    zIndex: { global: typeof zIndexTsGlobal };
  };
} = {
  colors: {
    global: { hex: globalColorHex, hsl: globalColorHsl, oklch: globalColorOklch, rgb: globalColorRgb },
    semantic: { hex: semanticColorHex, hsl: semanticColorHsl, oklch: semanticColorOklch, rgb: semanticColorRgb, dark: { hex: semanticColorHexDark, hsl: semanticColorHslDark, oklch: semanticColorOklchDark, rgb: semanticColorRgbDark } },
    themes: {
      "masterbrand": { hex: masterbrandColorHex, hsl: masterbrandColorHsl, oklch: masterbrandColorOklch, rgb: masterbrandColorRgb },
      "fuchsia-blue": { hex: fuchsiaBlueColorHex, hsl: fuchsiaBlueColorHsl, oklch: fuchsiaBlueColorOklch, rgb: fuchsiaBlueColorRgb },
      "fuchsia-orange": { hex: fuchsiaOrangeColorHex, hsl: fuchsiaOrangeColorHsl, oklch: fuchsiaOrangeColorOklch, rgb: fuchsiaOrangeColorRgb },
      "data-visualisation": { hex: dataVisualisationColorHex, hsl: dataVisualisationColorHsl, oklch: dataVisualisationColorOklch, rgb: dataVisualisationColorRgb },
    },
  },
  css: {
    global: { hex: globalCssHex, hsl: globalCssHsl, oklch: globalCssOklch, rgb: globalCssRgb },
    semantic: { hex: semanticCssHex, hsl: semanticCssHsl, oklch: semanticCssOklch, rgb: semanticCssRgb, dark: { hex: semanticCssHexDark, hsl: semanticCssHslDark, oklch: semanticCssOklchDark, rgb: semanticCssRgbDark }, darkMedia: { hex: semanticCssHexDarkMedia, hsl: semanticCssHslDarkMedia, oklch: semanticCssOklchDarkMedia, rgb: semanticCssRgbDarkMedia } },
    themes: {
      "masterbrand": { hex: masterbrandCssHex, hsl: masterbrandCssHsl, oklch: masterbrandCssOklch, rgb: masterbrandCssRgb },
      "fuchsia-blue": { hex: fuchsiaBlueCssHex, hsl: fuchsiaBlueCssHsl, oklch: fuchsiaBlueCssOklch, rgb: fuchsiaBlueCssRgb },
      "fuchsia-orange": { hex: fuchsiaOrangeCssHex, hsl: fuchsiaOrangeCssHsl, oklch: fuchsiaOrangeCssOklch, rgb: fuchsiaOrangeCssRgb },
      "data-visualisation": { hex: dataVisualisationCssHex, hsl: dataVisualisationCssHsl, oklch: dataVisualisationCssOklch, rgb: dataVisualisationCssRgb },
    },
    space: { global: spaceCssGlobal },
    radius: { global: radiusCssGlobal },
    breakpoints: { global: breakpointsCssGlobal },
    typography: { global: typographyCssGlobal, semantic: typographyCssSemantic },
    border: { global: borderCssGlobal },
    shadow: { global: shadowCssGlobal },
    motion: { global: motionCssGlobal },
    zIndex: { global: zIndexCssGlobal },
  },
  js: {
    global: { hex: globalJsHex, hsl: globalJsHsl, oklch: globalJsOklch, rgb: globalJsRgb },
    semantic: { hex: semanticJsHex, hsl: semanticJsHsl, oklch: semanticJsOklch, rgb: semanticJsRgb, dark: { hex: semanticJsHexDark, hsl: semanticJsHslDark, oklch: semanticJsOklchDark, rgb: semanticJsRgbDark } },
    themes: {
      "masterbrand": { hex: masterbrandJsHex, hsl: masterbrandJsHsl, oklch: masterbrandJsOklch, rgb: masterbrandJsRgb },
      "fuchsia-blue": { hex: fuchsiaBlueJsHex, hsl: fuchsiaBlueJsHsl, oklch: fuchsiaBlueJsOklch, rgb: fuchsiaBlueJsRgb },
      "fuchsia-orange": { hex: fuchsiaOrangeJsHex, hsl: fuchsiaOrangeJsHsl, oklch: fuchsiaOrangeJsOklch, rgb: fuchsiaOrangeJsRgb },
      "data-visualisation": { hex: dataVisualisationJsHex, hsl: dataVisualisationJsHsl, oklch: dataVisualisationJsOklch, rgb: dataVisualisationJsRgb },
    },
    space: { global: spaceJsGlobal },
    radius: { global: radiusJsGlobal },
    breakpoints: { global: breakpointsJsGlobal },
    typography: { global: typographyJsGlobal, semantic: typographyJsSemantic },
    border: { global: borderJsGlobal },
    shadow: { global: shadowJsGlobal },
    motion: { global: motionJsGlobal },
    zIndex: { global: zIndexJsGlobal },
  },
  json: {
    global: { hex: globalJsonHex, hsl: globalJsonHsl, oklch: globalJsonOklch, rgb: globalJsonRgb },
    semantic: { hex: semanticJsonHex, hsl: semanticJsonHsl, oklch: semanticJsonOklch, rgb: semanticJsonRgb, dark: { hex: semanticJsonHexDark, hsl: semanticJsonHslDark, oklch: semanticJsonOklchDark, rgb: semanticJsonRgbDark } },
    themes: {
      "masterbrand": { hex: masterbrandJsonHex, hsl: masterbrandJsonHsl, oklch: masterbrandJsonOklch, rgb: masterbrandJsonRgb },
      "fuchsia-blue": { hex: fuchsiaBlueJsonHex, hsl: fuchsiaBlueJsonHsl, oklch: fuchsiaBlueJsonOklch, rgb: fuchsiaBlueJsonRgb },
      "fuchsia-orange": { hex: fuchsiaOrangeJsonHex, hsl: fuchsiaOrangeJsonHsl, oklch: fuchsiaOrangeJsonOklch, rgb: fuchsiaOrangeJsonRgb },
      "data-visualisation": { hex: dataVisualisationJsonHex, hsl: dataVisualisationJsonHsl, oklch: dataVisualisationJsonOklch, rgb: dataVisualisationJsonRgb },
    },
    space: { global: spaceJsonGlobal },
    radius: { global: radiusJsonGlobal },
    breakpoints: { global: breakpointsJsonGlobal },
    typography: { global: typographyJsonGlobal, semantic: typographyJsonSemantic },
    border: { global: borderJsonGlobal },
    shadow: { global: shadowJsonGlobal },
    motion: { global: motionJsonGlobal },
    zIndex: { global: zIndexJsonGlobal },
  },
  less: {
    global: { hex: globalLessHex, hsl: globalLessHsl, oklch: globalLessOklch, rgb: globalLessRgb },
    semantic: { hex: semanticLessHex, hsl: semanticLessHsl, oklch: semanticLessOklch, rgb: semanticLessRgb, dark: { hex: semanticLessHexDark, hsl: semanticLessHslDark, oklch: semanticLessOklchDark, rgb: semanticLessRgbDark } },
    themes: {
      "masterbrand": { hex: masterbrandLessHex, hsl: masterbrandLessHsl, oklch: masterbrandLessOklch, rgb: masterbrandLessRgb },
      "fuchsia-blue": { hex: fuchsiaBlueLessHex, hsl: fuchsiaBlueLessHsl, oklch: fuchsiaBlueLessOklch, rgb: fuchsiaBlueLessRgb },
      "fuchsia-orange": { hex: fuchsiaOrangeLessHex, hsl: fuchsiaOrangeLessHsl, oklch: fuchsiaOrangeLessOklch, rgb: fuchsiaOrangeLessRgb },
      "data-visualisation": { hex: dataVisualisationLessHex, hsl: dataVisualisationLessHsl, oklch: dataVisualisationLessOklch, rgb: dataVisualisationLessRgb },
    },
    space: { global: spaceLessGlobal },
    radius: { global: radiusLessGlobal },
    breakpoints: { global: breakpointsLessGlobal },
    typography: { global: typographyLessGlobal, semantic: typographyLessSemantic },
    border: { global: borderLessGlobal },
    shadow: { global: shadowLessGlobal },
    motion: { global: motionLessGlobal },
    zIndex: { global: zIndexLessGlobal },
  },
  scss: {
    global: { hex: globalScssHex, hsl: globalScssHsl, oklch: globalScssOklch, rgb: globalScssRgb },
    semantic: { hex: semanticScssHex, hsl: semanticScssHsl, oklch: semanticScssOklch, rgb: semanticScssRgb, dark: { hex: semanticScssHexDark, hsl: semanticScssHslDark, oklch: semanticScssOklchDark, rgb: semanticScssRgbDark } },
    themes: {
      "masterbrand": { hex: masterbrandScssHex, hsl: masterbrandScssHsl, oklch: masterbrandScssOklch, rgb: masterbrandScssRgb },
      "fuchsia-blue": { hex: fuchsiaBlueScssHex, hsl: fuchsiaBlueScssHsl, oklch: fuchsiaBlueScssOklch, rgb: fuchsiaBlueScssRgb },
      "fuchsia-orange": { hex: fuchsiaOrangeScssHex, hsl: fuchsiaOrangeScssHsl, oklch: fuchsiaOrangeScssOklch, rgb: fuchsiaOrangeScssRgb },
      "data-visualisation": { hex: dataVisualisationScssHex, hsl: dataVisualisationScssHsl, oklch: dataVisualisationScssOklch, rgb: dataVisualisationScssRgb },
    },
    space: { global: spaceScssGlobal },
    radius: { global: radiusScssGlobal },
    breakpoints: { global: breakpointsScssGlobal },
    typography: { global: typographyScssGlobal, semantic: typographyScssSemantic },
    border: { global: borderScssGlobal },
    shadow: { global: shadowScssGlobal },
    motion: { global: motionScssGlobal },
    zIndex: { global: zIndexScssGlobal },
  },
  tailwind: {
    global: { hex: globalTailwindHex, hsl: globalTailwindHsl, oklch: globalTailwindOklch, rgb: globalTailwindRgb },
    semantic: { hex: semanticTailwindHex, hsl: semanticTailwindHsl, oklch: semanticTailwindOklch, rgb: semanticTailwindRgb },
    themes: {
      "masterbrand": { hex: masterbrandTailwindHex, hsl: masterbrandTailwindHsl, oklch: masterbrandTailwindOklch, rgb: masterbrandTailwindRgb },
      "fuchsia-blue": { hex: fuchsiaBlueTailwindHex, hsl: fuchsiaBlueTailwindHsl, oklch: fuchsiaBlueTailwindOklch, rgb: fuchsiaBlueTailwindRgb },
      "fuchsia-orange": { hex: fuchsiaOrangeTailwindHex, hsl: fuchsiaOrangeTailwindHsl, oklch: fuchsiaOrangeTailwindOklch, rgb: fuchsiaOrangeTailwindRgb },
      "data-visualisation": { hex: dataVisualisationTailwindHex, hsl: dataVisualisationTailwindHsl, oklch: dataVisualisationTailwindOklch, rgb: dataVisualisationTailwindRgb },
    },
    space: { global: spaceTailwindGlobal },
    radius: { global: radiusTailwindGlobal },
    breakpoints: { global: breakpointsTailwindGlobal },
    typography: { global: typographyTailwindGlobal },
    border: { global: borderTailwindGlobal },
    shadow: { global: shadowTailwindGlobal },
    motion: { global: motionTailwindGlobal },
    zIndex: { global: zIndexTailwindGlobal },
  },
  ts: {
    global: { hex: globalTsHex, hsl: globalTsHsl, oklch: globalTsOklch, rgb: globalTsRgb },
    semantic: { hex: semanticTsHex, hsl: semanticTsHsl, oklch: semanticTsOklch, rgb: semanticTsRgb, dark: { hex: semanticTsHexDark, hsl: semanticTsHslDark, oklch: semanticTsOklchDark, rgb: semanticTsRgbDark } },
    themes: {
      "masterbrand": { hex: masterbrandTsHex, hsl: masterbrandTsHsl, oklch: masterbrandTsOklch, rgb: masterbrandTsRgb },
      "fuchsia-blue": { hex: fuchsiaBlueTsHex, hsl: fuchsiaBlueTsHsl, oklch: fuchsiaBlueTsOklch, rgb: fuchsiaBlueTsRgb },
      "fuchsia-orange": { hex: fuchsiaOrangeTsHex, hsl: fuchsiaOrangeTsHsl, oklch: fuchsiaOrangeTsOklch, rgb: fuchsiaOrangeTsRgb },
      "data-visualisation": { hex: dataVisualisationTsHex, hsl: dataVisualisationTsHsl, oklch: dataVisualisationTsOklch, rgb: dataVisualisationTsRgb },
    },
    space: { global: spaceTsGlobal },
    radius: { global: radiusTsGlobal },
    breakpoints: { global: breakpointsTsGlobal },
    typography: { global: typographyTsGlobal, semantic: typographyTsSemantic },
    border: { global: borderTsGlobal },
    shadow: { global: shadowTsGlobal },
    motion: { global: motionTsGlobal },
    zIndex: { global: zIndexTsGlobal },
  },
}

export const colorTokens = tokens.colors
export const cssTokens = tokens.css
export const jsTokens = tokens.js
export const jsonTokens = tokens.json
export const lessTokens = tokens.less
export const scssTokens = tokens.scss
export const tailwindTokens = tokens.tailwind
export const tsTokens = tokens.ts

export const brand = {
  iconDark: { ico: './brand/icon-dark.ico', png: './brand/icon-dark.png', svg: './brand/icon-dark.svg' },
  iconLight: { ico: './brand/icon-light.ico', png: './brand/icon-light.png', svg: './brand/icon-light.svg' },
  icon: './brand/icon.svg',
  logo: { png: './brand/logo.png', svg: './brand/logo.svg' },
  placeholder: './brand/placeholder.svg',
}
